/**
 * ============================================================================
 *  earth/constants — locations, colors, math helpers (violet/purple/pink only)
 * ============================================================================
 */

export const HERO_LOCATIONS = [
  /* Amsterdam / Frankfurt render before London so that when the Europe
     cluster's <Html/> labels overlap on screen, London (rendered LAST) sits
     on top and receives pointer events instead of being hidden behind AMS. */
  { id: "ams", city: "Amsterdam", country: "Netherlands", flag: "🇳🇱", lat:  52.3676, lng:   4.9041,
    stats: { status: "operational", online: true, latency_ms: 11, cpu: 46, ram: 65, vps_count: 176, plans_from: 4 } },
  { id: "fra", city: "Frankfurt", country: "Germany",     flag: "🇩🇪", lat:  50.1109, lng:   8.6821,
    stats: { status: "operational", online: true, latency_ms:  8, cpu: 58, ram: 73, vps_count: 214, plans_from: 4 } },
  { id: "lon", city: "London",    country: "UK",          flag: "🇬🇧", lat:  51.5074, lng:  -0.1278,
    stats: { status: "operational", online: true, latency_ms: 12, cpu: 42, ram: 61, vps_count: 128, plans_from: 4 } },
  { id: "nyc", city: "New York",  country: "USA",         flag: "🇺🇸", lat:  40.7128, lng: -74.0060,
    stats: { status: "operational", online: true, latency_ms: 22, cpu: 63, ram: 71, vps_count: 302, plans_from: 5 } },
  { id: "yyz", city: "Toronto",   country: "Canada",      flag: "🇨🇦", lat:  43.6532, lng: -79.3832,
    stats: { status: "operational", online: true, latency_ms: 27, cpu: 38, ram: 55, vps_count:  94, plans_from: 5 } },
  { id: "dxb", city: "Dubai",     country: "UAE",         flag: "🇦🇪", lat:  25.2048, lng:  55.2708,
    stats: { status: "operational", online: true, latency_ms: 45, cpu: 51, ram: 68, vps_count: 138, plans_from: 6 } },
  { id: "sin", city: "Singapore", country: "Singapore",   flag: "🇸🇬", lat:   1.3521, lng: 103.8198,
    stats: { status: "operational", online: true, latency_ms: 38, cpu: 66, ram: 79, vps_count: 245, plans_from: 5 } },
  { id: "tyo", city: "Tokyo",     country: "Japan",       flag: "🇯🇵", lat:  35.6762, lng: 139.6503,
    stats: { status: "operational", online: true, latency_ms: 41, cpu: 55, ram: 70, vps_count: 187, plans_from: 5 } },
  { id: "bom", city: "Mumbai",    country: "India",       flag: "🇮🇳", lat:  19.0760, lng:  72.8777,
    stats: { status: "operational", online: true, latency_ms: 33, cpu: 44, ram: 62, vps_count: 108, plans_from: 6 } },
  { id: "syd", city: "Sydney",    country: "Australia",   flag: "🇦🇺", lat: -33.8688, lng: 151.2093,
    stats: { status: "operational", online: true, latency_ms: 58, cpu: 39, ram: 54, vps_count:  71, plans_from: 6 } },
  { id: "hkg", city: "Hong Kong", country: "Hong Kong",   flag: "🇭🇰", lat:  22.3193, lng: 114.1694,
    stats: { status: "operational", online: true, latency_ms: 39, cpu: 61, ram: 74, vps_count: 156, plans_from: 5 } },
];

/* Great-circle route pairs to visualise as animated data-packet arcs.  */
export const HERO_ROUTES = [
  ["lon", "nyc"], ["nyc", "yyz"], ["fra", "dxb"], ["ams", "lon"],
  ["dxb", "bom"], ["bom", "sin"], ["sin", "tyo"], ["tyo", "hkg"],
  ["hkg", "syd"], ["nyc", "fra"], ["lon", "sin"], ["yyz", "tyo"],
];

export const HERO_COLORS = {
  bg:         "#05010A",
  card:       "#111827",
  purple:     "#a855f7",
  purpleDeep: "#7c3aed",
  violet:     "#8b5cf6",
  pink:       "#ec4899",
  pinkLight:  "#f472b6",
  glow:       "#c084fc",
  white:      "#ffffff",
};

/**
 * Convert lat/lng (degrees) to a 3D point on a sphere of `radius`.
 * Mapping matches equirectangular textures from threejs.org/examples.
 */
export const latLngToVec3 = (lat, lng, radius = 1) => {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);
  return [
    -radius * Math.sin(phi) * Math.cos(theta),
     radius * Math.cos(phi),
     radius * Math.sin(phi) * Math.sin(theta),
  ];
};
